<template>


      <v-dialog v-model="dialog" ref="dialog" persistent max-width="3500px">
        <UserSalaryDeducationIndividual ref="modalForm" lazy-validation :loadFlag="loadFlag" @ok="modalFormOk">
        </UserSalaryDeducationIndividual>
        <v-card v-show="true" flat>
          <v-row class="rowBtn no-print-area">
            <v-spacer></v-spacer>
            <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'"></ryou-black-btn>
            <v-spacer></v-spacer>
          </v-row>
        </v-card>
      </v-dialog>

</template>

<script>
  import UserSalaryDeducationIndividual from "@/views/user/UserSalaryDeducationIndividual.vue";
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import { RyouTableMixins } from "@/mixins/RyouTableMixins";
  export default {
    name: "ClaimDetailDialog",
    mixins: [RyouTableMixins],
    components: {
      UserSalaryDeducationIndividual,
      RyouBlackBtn,
    },
    data: () => ({
      dialog: false,
    }),
    props: {
      loadFlag: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    methods: {
      handleCancel() {
        this.close();
      },
      modalFormOk() {
        this.$emit("closeDialog");
        this.handleCancel();
      },
      close() {
        this.dialog = false;
      },
      open(item) {
        this.dialog = true;
        setTimeout(() => {
          this.$refs.modalForm.setUserData(item)
        }, 10);       
      },
    },
  };
</script>
<style scoped>
  .rowBtn {
    width: 99%;
    padding-bottom: 20px;
  }
  @media print {
    .no-print-area {
      display: none;
    }
  }
</style>